<template lang="pug">
v-menu(left, content-class='small', offset-y)
  v-btn(slot='activator', small, flat)
    | Opties
    v-icon.primary--text fas fa-caret-down
  v-list
    slot
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// .small styling in vuetify.scss

i {
  margin-left: 5px;
}
</style>
